// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"72":"9305e070","301":"881bebe4","484":"a7558cbc"}[chunkId] + ".chunk.css");